import React from "react"
import classNames from "utils/classNames"

interface InfoRowProps {
  className?: string
  title: any
  subtitle?: any
}
const InfoRow = ({ className, title, subtitle }: InfoRowProps) => {
  return (
    <div className={classNames("grid grid-cols-12 gap-4", "mb-3", className)}>
      <div className="col-span-5">
        <span className="vt-muted">{title ?? "-"}</span>
      </div>
      {subtitle && (
        <>
          {" "}
          <div className="col-span-1">:</div>
          <div className="col-span-6">{subtitle ?? "-"}</div>
        </>
      )}
    </div>
  )
}

export const InfoRowDivider = ({
  title,
  className,
}: {
  title: any
  className?: any
}) => {
  return (
    <div className={className}>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-5">
          <span className="vt-highlight">{title}</span>
        </div>
      </div>
      <hr className="mt-1 mb-0" />
    </div>
  )
}

export default InfoRow
